import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { partnerConfigurationsAdminRouter } from './routing/partnerConfigurationsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { PartnerConfigurationsViewAccessControl } from './access-control/partnerConfigurationsAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'partner-configurations',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'partner-configurations-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [partnerConfigurationsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.PartnerSettings,
      subNavItems: [
        {
          route: 'app-admin-partner-configurations-list',
          subRoutes: ['app-admin-partner-configuration-types-list'],
          labelId: 'partnerConfigurations.navbar.label',
          // v3 renames "Manage partner configurations" → "Partner configs" per
          // Figma; group 1 of v3 Partner settings.
          labelIdV3: 'partnerConfigurations.navbar.label.v3',
          accessControl: PartnerConfigurationsViewAccessControl,
          positionNavV3: 2,
        },
      ],
    },
  ],
}

export default definition
